import classNames from '../../../../../../_virtual/index.mjs';
import React__default from 'react';
import modules_b0018d5a from './VisuallyHidden.module.css.mjs';

const VisuallyHidden = ({ children, focusable })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classNames(focusable ? modules_b0018d5a.focusable : modules_b0018d5a.hidden)
    }, children);

export { VisuallyHidden as default };
//# sourceMappingURL=VisuallyHidden.mjs.map
